import LogoutIcon from '@mui/icons-material/Logout';
import { Grid, IconButton } from '@mui/material';
import identity from 'lodash.identity';
import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import whiteLogoUrl from '../../assets/image/panalyt_logo_white.png';
import { FixedWidthGap } from '../common/components/layout';
import LanguageSwitcher from '../common/components/shell/LanguageSwitcher';
import { Header, Logo, StyledAppBar } from '../common/components/shell/Shell';
import { dataUploadRoute } from '../common/routes';
import InsufficientPermissionsErrorComponent from '../common/v2/common/components/errors/pages/InsufficientPermisionsErrorComponent';
import {
  useAuthenticationServiceContext,
  useDomainContext,
  useEffectiveRoleViewAuthorizationServiceContext,
} from '../common/v2/context/contexts';
import { PrivateRoute } from './PrivateRoute';

export const DataUploadOnlyApp = () => {
  const authService = useAuthenticationServiceContext();
  const authorizationService =
    useEffectiveRoleViewAuthorizationServiceContext();
  const route = dataUploadRoute(authorizationService);
  const domain = useDomainContext();

  if (!route.isEnabled) {
    return <InsufficientPermissionsErrorComponent resetError={identity} />;
  }
  return (
    <Grid container>
      <StyledAppBar>
        <Grid
          container
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            position: 'relative',
          }}
        >
          <Logo src={whiteLogoUrl} className="intercom_appbar_logo" />
          <Grid
            item
            container
            sx={{
              justifyContent: 'flex-end',
              position: 'absolute',
              right: 0,
            }}
          >
            <LanguageSwitcher />
            <FixedWidthGap $gap="8px" />
            <IconButton
              onClick={() => {
                localStorage.clear();
                void authService.logOutUser(domain);
              }}
              style={{ color: 'white' }}
            >
              <LogoutIcon />
            </IconButton>
          </Grid>
        </Grid>
      </StyledAppBar>
      <main>
        <Header />
        <Switch>
          <PrivateRoute key={route.id} component={route.comp()} {...route} />
          <Redirect from="*" to={`${route.path}?tag=upload`} />
        </Switch>
      </main>
    </Grid>
  );
};
